import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FreeTrialForm } from "./FreeTrialForm";
import { FreeTrialComplete } from "./FreeTrialComplete";
import { FreeTrialFormData } from "../model/free-trial-types";
import { useFreeTrial } from "../hooks/use-free-trial";

type FreeTrialStep = "form" | "complete";

/**
 * FreeTrialFlow - 무료체험 신청 프로세스 관리
 */
export function FreeTrialFlow() {
  const navigate = useNavigate();
  const { submitFreeTrial, isLoading } = useFreeTrial();
  const [step, setStep] = useState<FreeTrialStep>("form");
  const [formData, setFormData] = useState<FreeTrialFormData | null>(null);

  const handleFormSubmit = async (data: FreeTrialFormData) => {
    setFormData(data);
    const result = await submitFreeTrial(data);
    if (result.success) {
      setStep("complete");
    }
  };

  return (
    <div className="flex-1 flex items-center justify-center p-4">
      {step === "form" && (
        <FreeTrialForm onSubmit={handleFormSubmit} isLoading={isLoading} />
      )}
      {step === "complete" && <FreeTrialComplete />}
    </div>
  );
}
